import { useState } from "react";
import { InputLabel, MenuItem, FormControl, Select } from "@material-ui/core"
import {
    OverviewCardWrapper,
    OverviewCardTop,
    SelectContainer,
    Hr
} from '../dashboard-overview.style'
import RecentActivityItem from "./recent-activities-item";


const RecentActivities = () => {
    const [sort, setSort] = useState('');

    const handleChange = (event) => {
        console.log(event.target.value)
        setSort(event.target.value);
    };
    return (
        <OverviewCardWrapper>
            <OverviewCardTop>
                <span>
                    recent activities
                </span>
                <SelectContainer>
                    <select onChange={handleChange}>
                        <option value="">Sort by</option>
                        <option value="date">Date</option>
                        <option value="time">Time</option>
                        <option value="day">Day</option>
                    </select>
                </SelectContainer>
            </OverviewCardTop>
            <Hr />
            <RecentActivityItem />
            <RecentActivityItem />
            <RecentActivityItem />
            <RecentActivityItem />
        </OverviewCardWrapper>
    )
}

export { RecentActivities }
